import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RichTextEditorModule } from "@webapp/shared/rich-text-editor/rich-text-editor.module";
import { UiModule } from "@webapp/ui/ui.module";
import { NoReflectionsComponent } from "./components/no-reflections/no-reflections.component";
import { ReflectionContributorListComponent } from "./components/reflection-contributor-list/reflection-contributor-list.component";
import { TeamReflectionsComponent } from "./components/team-reflections/team-reflections.component";
import { ReflectionFormComponent } from "./components/reflection-form/reflection-form.component";

@NgModule({
  declarations: [TeamReflectionsComponent, ReflectionContributorListComponent, ReflectionFormComponent, NoReflectionsComponent],
  imports: [CommonModule, UiModule, RichTextEditorModule],
})
export class ReflectionsModule {}
